import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      name: 'desktop',
      path: '/',
      component: () => import(/* webpackChunkName: "desktop" */ './misc/src/newDesktop.vue'),
      // redirect: { name: 'radishes' },
      meta: {
        title: '工作台',
      },
    },
    {
      name: 'newdesktop',
      path: '/newdesktop',
      component: () => import(/* webpackChunkName: "newDesktop" */ './misc/src/newnewDesktop.vue'),
      // redirect: { name: 'radishes' },
      meta: {
        title: '工作台',
      },
    },
    {
      name: 'wechatmsg',
      path: '/wechatmsg',
      component: () => import(/* webpackChunkName: "wechatMsg" */ './misc/src/wechatMsg.vue'),
      // redirect: { name: 'radishes' },
    },
    {
      name: 'weimingpian',
      path: '/weimingpian',
      component: () => import(/* webpackChunkName: "weimingpian" */ './misc/src/newWeiMingPian.vue'),
    },
    {
      name: 'weimingpiandetail',
      path: '/weimingpiandetail/:id',
      component: () => import(/* webpackChunkName: "weimingpiandetail" */ './misc/src/newWeiMingPianDetail.vue'),
    },
    {
      name: 'bulletins',
      path: '/bulletins',
      component: () => import(/* webpackChunkName: "bulletins" */ './misc/src/bulletin/bulletins3.vue'),
      meta: {
        title: '情报',
      },
    },
    {
      name: 'categories',
      path: '/categories',
      component: () => import(/* webpackChunkName: "categories" */ './misc/src/categories.vue'),
      meta: {
        title: '职能模块',
      },
    },
    {
      name: 'forecast',
      path: '/forecast',
      component: () => import(/* webpackChunkName: "forecast" */ './misc/src/forecast/enter.vue'),
      meta: {
        title: '预测血库',
      },
    },
    {
      name: 'LeaderFlow',
      path: '/LeaderFlow',
      component: () => import(/* webpackChunkName: "forecast" */ './misc/src/LeaderFlow/index.vue'),
      meta: {
        title: '高管流动',
      },
    },
    // {
    //   name: "questions",
    //   path: "/questions",
    //   component: misc.questions
    // },
    // {
    {
      name: 'users',
      path: '/users',
      component: () => import(/* webpackChunkName: "users" */ './misc/src/users.vue'),
      props: true,
      meta: {
        title: '用户',
      },
    },
    {
      name: 'review',
      path: '/review',
      component: () => import(/* webpackChunkName: "users" */ './misc/src/review/index.vue'),
      props: true,
      meta: {
        title: 'review',
      },
    },
    {
      name: 'rili',
      path: '/rili',
      component: () => import(/* webpackChunkName: "users" */ './misc/src/rili/rili.vue'),
      props: true,
      meta: {
        title: '日历',
      },
    },
    {
      name: 'chuangguan',
      path: '/chuangguan',
      component: () => import(/* webpackChunkName: "chuangguan" */ './misc/src/chuangguan/index.vue'),
      meta: {
        title: '闯关',
      },
    },
    {
      name: 'permissions',
      path: '/permissions',
      component: () => import(/* webpackChunkName: "permissions" */ './misc/src/permissions.vue'),
      meta: {
        title: '权限',
      },
    },
    {
      name: 'kpisetting',
      path: '/kpisetting',
      component: () => import(/* webpackChunkName: "kpisetting" */ './misc/src/kpisetting.vue'),
      meta: {
        title: '业绩',
      },
    },
    {
      name: 'groups',
      path: '/groups',
      component: () => import(/* webpackChunkName: "groups" */ './misc/src/groups.vue'),
      meta: {
        title: '用户组',
      },
    },
    {
      name: 'fileupload',
      path: '/fileupload',
      component: () => import(/* webpackChunkName: "fileupload" */ './file/src/pages/FileList.vue'),
      meta: {
        title: '文件上传',
      },
    },
    {
      path: '/industries',
      component: () => import(/* webpackChunkName: "industries" */ './misc/src/industries.vue'),
      meta: {
        title: '行业',
      },
    },
    // {
    //   path: "/messages",
    //   component: misc.messages
    // },
    // {
    //   path: "/helps",
    //   component: misc.helps
    // },
    {
      name: 'bugs',
      path: '/bugs',
      component: () => import(/* webpackChunkName: "bugs" */ './misc/src/bugs.vue'),
      meta: {
        title: 'bugs',
      },
    },
    {
      path: '/monitor',
      component: () => import(/* webpackChunkName: "monitor" */ './misc/src/monitor.vue'),
    },
    {
      name: 'contactlists',
      path: '/contactlists',
      component: () => import(/* webpackChunkName: "contactlists" */ './misc/src/contactlists.vue'),
      meta: {
        title: '通讯录',
      },
    },
    // {
    //   name: 'createcompany',
    //   path: '/createcompany',
    //   component: () => import(/* webpackChunkName: "createCompany" */ './misc/src/createCompany.vue'),
    // },
    {
      name: 'teammanage',
      path: '/teammanage',
      component: () => import(/* webpackChunkName: "teammanage" */ './misc/src/teammanage.vue'),
      meta: {
        title: '团队管理',
      },
    },
    // {
    //   name: 'training',
    //   path: '/training',
    //   component: () => import(/* webpackChunkName: "training" */ './misc/src/training-new.vue'),
    // },
    {
      name: 'training',
      path: '/training',
      component: () => import(/* webpackChunkName: "training" */ './misc/src/new-training.vue'),
      meta: {
        title: '培训',
      },
    },
    {
      name: 'training-edit',
      path: '/training-edit',
      component: () => import(/* webpackChunkName: "trainingEdit" */ './misc/src/training-edit.vue'),
      meta: {
        title: '培训内容编辑',
      },
    },
    {
      name: 'faq',
      path: '/faq',
      component: () => import(/* webpackChunkName: "faq" */ './misc/src/faq.vue'),
    },
    {
      path: '/templateupload',
      component: () => import(/* webpackChunkName: "templateUpload" */ './misc/src/template-upload2.vue'),
      meta: {
        title: '模板上传',
      },
    },
    {
      path: '/templateuploadnew',
      component: () => import(/* webpackChunkName: "worktemplate" */ './misc/src/template-upload-new.vue'),
      meta: {
        title: '新版模板上传',
      },
    },
    {
      path: '/kpisnew',
      component: () => import(/* webpackChunkName: "kpisnew" */ './misc/src/kpisnew.vue'),
      meta: {
        title: 'KPI',
      },
    },
    {
      path: '/project/:projectId/report',
      component: () => import(/* webpackChunkName: "projectReport" */ './misc/src/project-report.vue'),
      props: true,
    },
    {
      path: '/companylist',
      name: 'companies',
      component: () => import(/* webpackChunkName: "companyList" */ './company/src/companyList.vue'),
    },
    {
      path: '/radish',
      name: 'radishes',
      component: () => import(/* webpackChunkName: "radish" */ './radish/src/quick/radish-21.vue'),
    },
    {
      path: '/radish2',
      name: 'radishes2',
      component: () => import(/* webpackChunkName: "radish" */ './radish/src/quick/radish2-22.vue'),
    },
    {
      path: '/radish-list',
      component: () => import(/* webpackChunkName: "radishList" */ './radish/src/radish-list.vue'),
    },
    {
      path: '/radish-list/company/:company',
      component: () => import(/* webpackChunkName: "radishList" */ './radish/src/radish-list.vue'),
      props: true,
    },
    {
      path: '/radish-list/company/:company/department/:department',
      component: () => import(/* webpackChunkName: "radishList" */ './radish/src/radish-list.vue'),
      props: true,
    },
    {
      path: '/radish-list/project/:pid',
      component: () => import(/* webpackChunkName: "radishListPro" */ './radish/src/radish-list-pro.vue'),
      props: true,
    },
    {
      path: '/radish-dup',
      component: () => import(/* webpackChunkName: "radishDup" */ './misc/src/workbench2/radish-dup2.vue'),
    },
    {
      path: '/radish-detail/:id',
      component: () => import(/* webpackChunkName: "radishDetail" */ './radish/src/radish-detail.vue'),
      props: true,
    },
    {
      path: '/radish-detail-blank/:id',
      name: 'radish-detail-blank',
      component: () =>
        import(/* webpackChunkName: "radishDetailBlank" */ './radish/src/detail/radish-detail-blank.vue'),
      props: true,
    },
    {
      path: '/radish-add',
      component: () => import(/* webpackChunkName: "radishAddPage" */ './radish/src/radish-add-page.vue'),
      meta: {
        title: '新增人选',
      },
    },
    {
      path: '/radish-detail-page',
      component: () => import(/* webpackChunkName: "radishDetailPage" */ './radish/src/radish-detail-page.vue'),
    },
    {
      path: '/radish-quick-add',
      component: () => import(/* webpackChunkName: "radishQuickAdd" */ './radish/src/radish-quick-add.vue'),
      meta: {
        title: '快速新增人选',
      },
    },
    {
      path: '/kpi2',
      component: () => import(/* webpackChunkName: "kpi" */ './misc/src/kpi.vue'),
      meta: {
        title: 'KPI统计',
      },
    },
    {
      path: '/kpi3',
      component: () => import(/* webpackChunkName: "kpi" */ './misc/src/kpi2022.vue'),
      meta: {
        title: 'KPI统计',
      },
    },
    {
      path: '/kpi-goal',
      component: () => import(/* webpackChunkName: "kpi" */ './radish/src/kpi/kpi-goal-page.vue'),
      meta: {
        title: 'KPI目标',
      },
    },
    {
      path: '/kpi-goal-set',
      component: () => import(/* webpackChunkName: "kpi" */ './radish/src/kpi/kpi-goal-set-page.vue'),
      meta: {
        title: 'KPI目标设置',
      },
    },
    {
      path: '/kpi-kpi',
      component: () => import(/* webpackChunkName: "kpi" */ './radish/src/kpi/kpi-kpi-page.vue'),
    },
    {
      path: '/kpi-yj',
      component: () => import(/* webpackChunkName: "kpi" */ './radish/src/kpi/kpi-yeji-page.vue'),
    },
    {
      path: '/tag-completion',
      component: () => import(/* webpackChunkName: "tagCompletion" */ './radish/src/tag-completion.vue'),
      meta: {
        title: '标签完成度',
      },
    },
    {
      path: '/projs',
      name: 'projects',
      component: () => import(/* webpackChunkName: "Projects" */ './project/src/pages/Projects.vue'),
    },
    {
      path: '/proj/:projectId',
      name: 'project',
      component: () => import(/* webpackChunkName: "ProjectDetail" */ './project/src/pages/ProjectDetail.vue'),
      props: true,
    },
    {
      path: '/project20/:projectId',
      name: 'project20',
      component: () =>
        import(/* webpackChunkName: "ProjectDetail" */ './project/src/components/ProjectDetail20/index.vue'),
      props: true,
    },
    {
      path: '/f',
      component: () => import(/* webpackChunkName: "FileList" */ './file/src/pages/FileList.vue'),
    },
    {
      path: '/statistics',
      component: () => import(/* webpackChunkName: "graphy" */ './statistics/src/graphy.vue'),
      meta: {
        title: '人才流动统计',
      },
    },
    {
      path: '/beMonitor',
      component: () => import(/* webpackChunkName: "graphy" */ './beMonitor/src/graphy.vue'),
      meta: {
        title: '网站后端性能分析',
      },
    },
    {
      path: '/cvEval',
      component: () => import(/* webpackChunkName: "cvEval" */ './misc/src/cvEval.vue'),
      meta: {
        title: '简历打分',
      },
    },
    {
      path: '/finance',
      component: () => import(/* webpackChunkName: "finance" */ './company/src/finance.vue'),
      meta: {
        title: '财务报表',
      },
    },

    {
      path: '/test_company_grade',
      component: () => import(/* webpackChunkName: "finance" */ './company/src/component/TestCompanyGrade.vue'),
    },
    // {
    //   path: '/report',
    //   beforeEnter: async (to, from, next) => {
    //     const role = window.app.user['角色']
    //     if (role !== '管理员' && role !== '行政') {
    //       return next(false)
    //     }
    //     next()
    //   },
    //   component: () => import(/* webpackChunkName: "CommendReport" */ './project/src/pages/CommendReport.vue'),
    // },
    {
      path: '/salarystatistics',
      component: () => import(/* webpackChunkName: "SalaryStatistics" */ './project/src/pages/SalaryStatistics.vue'),
      meta: {
        title: '薪酬',
      },
    },
    {
      path: '/wechatfiles',
      component: () => import(/* webpackChunkName: "Wechatfiles" */ './project/src/pages/Wechatfiles.vue'),
      meta: {
        title: '微信和邮箱文件',
      },
    },
    {
      path: '/user-bulletin-permissions',
      component: () =>
        import(/* webpackChunkName: "userBulletinPermissions" */ './misc/src/user-bulletin-permissions.vue'),
      meta: {
        title: '情报权限',
      },
    },
    // {
    //   path: '/tmp-bulletins',
    //   component: () => import(/* webpackChunkName: "tmpBulletins" */ './misc/src/tmp-bulletins.vue'),
    // },
    {
      path: '/offerTable',
      // component: () => import(/* webpackChunkName: "offerTable" */ './company/src/offerTable.vue'),
      component: () => import(/* webpackChunkName: "offerTable" */ './company/src/newOfferTable.vue'),
      meta: {
        title: 'offer统计',
      },
    },
    {
      path: '/tmp-radish',
      component: () => import(/* webpackChunkName: "tmp-radish" */ './radish/src/tmp-radish.vue'),
    },
    // {
    //   path: '/lists',
    //   component: () => import(/* webpackChunkName: "Lists" */ './misc/src/lists.vue'),
    // },
    {
      path: '/cvinfo/:defaultQuery',
      component: () => import(/* webpackChunkName: "Cvinfo" */ './misc/src/Cvinfo.vue'),
      meta: {
        title: '推荐历史',
      },
    },
    {
      path: '/cvinfo',
      component: () => import(/* webpackChunkName: "Cvinfo" */ './misc/src/Cvinfo.vue'),
      meta: {
        title: '推荐历史',
      },
    },
    {
      path: '/cvinfoV2',
      component: () => import(/* webpackChunkName: "cvinfoV2" */ './misc/src/CvinfoV2.vue'),
      meta: {
        title: '推荐历史V2',
      },
    },
    {
      path: '/cvupload',
      component: () => import(/* webpackChunkName: "cvupload" */ './radish/src/cvupload/CvUpload.vue'),
      meta: {
        title: '新增人选',
      },
    },
    {
      path: '/cvcompare',
      component: () => import(/* webpackChunkName: "cvupload" */ './radish/src/cvupload/CvCompare.vue'),
      meta: {
        title: '手动对比',
      },
    },
    {
      path: '/project/:projectId/mapping',
      component: () => import(/* webpackChunkName: "ProjectMapping" */ './project/src/pages/ProjectMapping.vue'),
    },
    {
      path: '/company-progress/:companyName',
      component: () => import(/* webpackChunkName: "CompanyProgress" */ './misc/src/CompanyProgress.vue'),
    },
    {
      path: '/company-recomend-namelist/:companyName',
      component: () =>
        import(/* webpackChunkName: "CompanyRecomendNamelist" */ './misc/src/CompanyRecomendNamelist.vue'),
    },
    {
      path: '/bindmanager',
      component: () => import(/* webpackChunkName: "bindmanager" */ './radish/src/manager-bind.vue'),
    },
    {
      path: '/sysnotify',
      component: () => import(/* webpackChunkName: "sysnotify" */ './misc/src/sysnotify.vue'),
      meta: {
        title: '系统公告',
      },
    },
    // {
    //   path: '/company/:companyId',
    //   name: 'company',
    //   component: () => import(/* webpackChunkName: "ProjectDetail" */ './company/src/fullCompany.vue'),
    //   props: true,
    // },
    {
      path: '/oldcompany/:companyId',
      // path: '/newcompany/:companyId',
      name: 'oldcompany',
      component: () => import(/* webpackChunkName: "ProjectDetail" */ './company/src/NewFullCompany.vue'),
      props: true,
    },
    {
      path: '/companyV1/:companyId',
      // path: '/newcompany/:companyId',
      name: 'newcompany2.0',
      component: () => import(/* webpackChunkName: "ProjectDetail" */ './company/src/NewFullCompany2.0'),
      props: true,
    },
    {
      path: '/knowledgebase',
      component: () => import(/* webpackChunkName: "knowledgebase" */ './company/src/knowledgebase.vue'),
      meta: {
        title: '知识库',
      },
    },
    {
      path: '/starofweek',
      component: () => import(/* webpackChunkName: "starofweek" */ './misc/src/starofweek.vue'),
      meta: {
        title: '本周公告',
      },
    },
    {
      path: '/school',
      component: () => import(/* webpackChunkName: "school" */ './misc/src/school.vue'),
      meta: {
        title: '学校排名',
      },
    },
    {
      path: '/debugrawfile',
      component: () => import(/* webpackChunkName: "debugrawfile" */ './commons/debugrawfile.vue'),
      meta: {
        title: '测试文件上传',
      },
    },
    {
      name: 'workbench',
      path: '/workbench',
      component: () => import(/* webpackChunkName: "workbench" */ './misc/src/workbench.vue'),
      meta: {
        title: '行政工作台',
      },
    },
    {
      name: 'workbench2',
      path: '/workbench2',
      component: () => import(/* webpackChunkName: "workbench" */ './misc/src/workbench2/workbench2.vue'),
      meta: {
        title: '行政工作台2',
      },
    },
    {
      name: 'ahuntlist',
      path: '/ahuntlist',
      component: () => import(/* webpackChunkName: "ahuntlist" */ './company/src/hunting/huntList.vue'),
      meta: {
        title: '小阿打猎',
      },
    },
    {
      name: 'catalogue',
      path: '/catalogue/:routerType',
      component: () => import(/* webpackChunkName: "catalogue" */ './misc/src/newTraining/training.vue'),
      props: true,
    },
    {
      name: 'listdocuments',
      path: '/listdocuments',
      component: () => import(/* webpackChunkName: "listdocuments" */ './file/src/pages/ListDocuments.vue'),
      props: true,
      meta: {
        title: '资源库搜索中心',
      },
    },
    {
      name: 'allcontactlist',
      path: '/allcontactlist',
      component: () => import(/* webpackChunkName: "allcontactlist" */ './file/src/pages/ContactList.vue'),
      props: true,
      meta: {
        title: 'list总表',
      },
    },
    {
      name: 'testAddProject',
      path: '/testAddProject',
      component: () => import(/* webpackChunkName: "testAddProject" */ './project/src/pages/AddProject.vue'),
      props: true,
    },
    {
      name: 'group-management',
      path: '/group-management',
      component: () => import(/* webpackChunkName: "groupManagement" */ './misc/src/groupManagement.vue'),
      meta: {
        title: '组织管理',
      },
    },
    {
      name: 'newprojects',
      path: '/projects',
      component: () => import(/* webpackChunkName: "newprojects" */ './project/src/pages/NewProjectList.vue'),
    },
    {
      name: 'points',
      path: '/points',
      component: () => import(/* webpackChunkName: "points" */ './radish/src/points/points.vue'),
      meta: {
        title: '体系化积分',
      },
    },
    {
      path: '/checkRecommend',
      component: () => import(/* webpackChunkName: "checkRecommend" */ './misc/src/checkRecommend.vue'),
      meta: {
        title: '推荐报告匹配',
      },
    },
    {
      name: '个人中心',
      path: '/user-detail',
      component: () => import(/* webpackChunkName: "userDetail" */ './misc/src/userDetail.vue'),
      meta: {
        title: '个人中心',
      },
    },
    {
      name: '设置提供人',
      path: '/consult-helper',
      component: () => import(/* webpackChunkName: "consultHelper" */ './misc/src/consult-helper.vue'),
      meta: {
        title: '设置提供人',
      },
    },
    {
      path: '/applyTempLogin',
      component: () => import(/* webpackChunkName: "applyTempLogin" */ './misc/src/ApplyForTempLoginDialog.vue'),
    },
    {
      path: '/createProject',
      component: () =>
        import(/* webpackChunkName: "createProject" */ './project/src/components/NewCreateProject/NewCreateProject.vue'),
    },
    {
      path: '/createProject20',
      name: 'createProject20',
      component: () =>
        import(/* webpackChunkName: "createProject20" */ './project/src/components/CreateProject20/CreateProject20.vue'),
    },
    {
      path: '/addHr/:cid',
      component: () =>
        import(/* webpackChunkName: "createProject20" */ './project/src/components/CreateProject20/AddHr.vue'),
      props: true,
    },
    {
      path: '/companyZhaopin',
      component: () =>
        import(/* webpackChunkName: "companyZhaopin" */ './company/src/splitComponent/CompanyZhaopin.vue'),
    },
    {
      path: '/talentFlow',
      component: () => import(/* webpackChunkName: "talentFlow" */ './radish/src/components/talentFlow.vue'),
      meta: {
        title: '人才流动汇总',
      },
    },
    {
      path: '/NewCompanyList',
      component: () => import(/* webpackChunkName: "NewCompanyList" */ './company/src/NewCompanyList'),
      meta: {
        title: '公司',
      },
    },
    {
      path: '/newTalentFlow',
      component: () => import(/* webpackChunkName: "newTalentFlow" */ './misc/src/TalentFlow/TalentFlow'),
    },
    {
      path: '/NewAddCompany',
      name: 'NewAddCompany',
      component: () => import(/* webpackChunkName: "radishList" */ './company/src/NewAddCompany'),
    },
    {
      path: '/ClientCompany/:companyId/:type',
      component: () =>
        import(/* webpackChunkName: "radishList" */ './company/src/NewFullCompany2.0/NewFullCompanyComponents/ClientPage'),
      props: true,
    },
    {
      path: '/WeekListTogle',
      component: () => import(/* webpackChunkName: "WeekListTogle" */ './misc/src/WeekListTogle'),
    },
    {
      path: '/testPlugin',
      name: 'testPlugin',
      component: () => import(/* webpackChunkName: "testPlugin" */ './commons/testPlugin.vue'),
    },
    {
      path: '/getLiepinSearchPlugin',
      component: () => import(/* webpackChunkName: "getLiepinSearchPlugin" */ './commons/getLiepinSearchPlugin.vue'),
    },
    {
      path: '/clientManage',
      name: 'clientManage',
      component: () => import(/* webpackChunkName: "clientManage" */ './misc/src/clientManage'),
    },
    {
      path: '/RadishManage',
      name: 'RadishManage',
      component: () => import(/* webpackChunkName: "radishManage" */ './misc/src/RadishManage'),
    },
    {
      path: '/testPhoneNumber',
      name: 'TestPhoneNumber',
      component: () => import(/* webpackChunkName: "TestPhoneNumber" */ './commons/TestPhoneNumber'),
    },
    {
      path: '/ZnAlphaLogs',
      name: 'ZnAlphaLogs',
      component: () => import(/* webpackChunkName: "desktop" */ './misc/src/ZnAlpha/ZnAlphaLogs'),
    },
    {
      path: '/PeixunAdmin',
      name: 'PeixunAdmin',
      component: () => import(/* webpackChunkName: "peixun" */ './misc/src/PeixunAdmin/index'),
    },
    {
      path: '/PeixunStudents',
      name: 'PeixunStudents',
      component: () => import(/* webpackChunkName: "peixun" */ './misc/src/PeixunAdmin/students'),
    },
    {
      path: '/companyV2/:companyId',
      name: 'companyV2',
      component: () => import(/* webpackChunkName: "CompanyDetail" */ './company/src/FullCompanyV2'),
      props: true,
    },
    {
      path: '/PeixunCeping',
      name: 'PeixunCeping',
      component: () => import(/* webpackChunkName: "peixun" */ './misc/src/PeixunAdmin/ceping'),
    },
    {
      path: '/dizhu',
      name: 'dizhu',
      component: () => import(/* webpackChunkName: "peixun" */ './misc/src/dizhu/index'),
    },
    {
      path: '/userMedal',
      name: 'userMedal',
      component: () => import(/* webpackChunkName: "peixun" */ './misc/src/UserMedal'),
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import(/* webpackChunkName: "peixun" */ './misc/src/dashboard/index'),
    },
    {
      path: '/Summary',
      name: 'Summary',
      component: () => import(/* webpackChunkName: "summary" */ './misc/src/WorkSummary/companySummary'),
    },
    {
      path: '/UserSummary/:account',
      name: 'UserSummary',
      component: () => import(/* webpackChunkName: "userSummary" */ './misc/src/WorkSummary/userSummary'),
      props: true,
    },
    // {
    //   path: '/myrencai',
    //   name: 'myrencai',
    //   component: () => import(/* webpackChunkName: "myrencai" */ './radish/src/myrencai/index'),
    // },
    {
      path: '/fav2',
      name: 'fav2',
      component: () => import(/* webpackChunkName: "fav2" */ './radish/src/fav2/index'),
    },
    // {
    //   path: '/fav-radish/:id',
    //   component: () => import(/* webpackChunkName: "myrencai" */ './radish/src/myrencai/fav-radish-list'),
    //   props: true,
    // },
    {
      path: '/company/:companyId',
      name: 'company',
      component: () => import(/* webpackChunkName: "CompanyDetail" */ './company/src/FullCompanyV2'),
      props: true,
    },
    {
      path: '/ProjectFollowV2',
      name: 'ProjectFollowV2',
      component: () => import(/* webpackChunkName: "ProjectFollowV2" */ './misc/src/ProjectFollowV2'),
    },
    {
      path: '/ProjectFollowV2Member',
      name: 'ProjectFollowV2Member',
      component: () => import(/* webpackChunkName: "ProjectFollowV2Member" */ './misc/src/ProjectFollowV2Member'),
    },
    {
      path: '/SimpleDesktop',
      name: 'SimpleDesktop',
      component: () => import(/* webpackChunkName: "ProjectFollowV2Member" */ './misc/src/SimpleDesktop'),
    },
    {
      path: '/SimpleFinance',
      name: 'SimpleFinance',
      component: () => import(/* webpackChunkName: "ProjectFollowV2Member" */ './misc/src/SimpleFinance'),
    },
    {
      path: '/Xiaolanben',
      name: 'Xiaolanben',
      component: () => import(/* webpackChunkName: "ProjectFollowV2Member" */ './misc/src/Xiaolanben'),
    },
    {
      path: '/SimpleUserFinance',
      name: 'SimpleUserFinance',
      component: () => import(/* webpackChunkName: "ProjectFollowV2Member" */ './misc/src/SimpleFinance/userIndex'),
    },
    {
      path: '/FinancePercent',
      name: 'FinancePercent',
      component: () => import(/* webpackChunkName: "ProjectFollowV2Member" */ './misc/src/SimpleFinance/FinancePercent'),
    },
    {
      path: '/FinancePercentProgress',
      name: 'FinancePercentProgress',
      component: () => import(/* webpackChunkName: "ProjectFollowV2Member" */ './misc/src/SimpleFinance/FinancePercentProgress'),
    },
    {
      path: '/TestProjectList',
      name: 'TestProjectList',
      component: () => import(/* webpackChunkName: "ProjectFollowV2Member" */ './project/src/components/ProjectGroupList/index.vue'),
    },
    {
      path: '*',
      component: () => import(/* webpackChunkName: "Error404" */ './misc/src/Error404.vue'),
    },
  ],
})

router.beforeEach((to, from, next) => {
  setDocumentTitle(to)
  next()
})

async function setDocumentTitle(to) {
  const {
    name,
    meta,
    params: { projectId, id, companyId, routerType },
  } = to
  let companyFetchRes = null
  let radishSimpleRes = null

  switch (name) {
    case 'radishes':
      document.title = '人才管理'
      break
    case 'radishes2':
      document.title = '人才快搜'
      break
    case 'clientManage':
      document.title = '客户管理'
      break
    case 'RadishManage':
      document.title = '候选人'
      break
    case 'ProjectFollowV2':
      document.title = '任务管理-团队长'
      break
    case 'ProjectFollowV2Member':
      document.title = '任务管理-成员'
      break
    case 'NewAddCompany':
      document.title = '新建公司'
      break
    case 'createProject20':
      document.title = '新建项目'
      break
    case 'radish-detail-blank':
      if (!id) break
      radishSimpleRes = await app.service('radish').simpleFetch({ _id: id, fields: { 姓名: 1 } })
      if (radishSimpleRes && radishSimpleRes.status === 'success') {
        document.title = radishSimpleRes.data && radishSimpleRes.data.姓名 ? radishSimpleRes.data.姓名 : '人选不存在'
      }
      break
    case 'companies':
      document.title = '公司管理'
      break
    case 'newcompany':
      if (!companyId) break
      companyFetchRes = await window.app.service('company').fetch(companyId)
      if (
        companyFetchRes &&
        companyFetchRes.status === 'success' &&
        companyFetchRes.data &&
        companyFetchRes.data.简称
      ) {
        document.title = `${companyFetchRes.data.简称}`
      }
      break
    case 'newprojects':
      document.title = '项目管理'
      break
    case 'catalogue':
      if (!routerType) break
      document.title = routerType
      break
    case 'project':
    case 'project20':
      if (!projectId) break
      // eslint-disable-next-line no-case-declarations
      const { 项目名称 } = await window.app.service('project').fetch(projectId)
      document.title = `${项目名称}`
      break
    case 'company':
      if (!companyId) break
      // eslint-disable-next-line no-case-declarations
      companyFetchRes = await window.app.service('company').fetch(companyId)
      if (
        companyFetchRes &&
        companyFetchRes.status === 'success' &&
        companyFetchRes.data &&
        companyFetchRes.data.简称
      ) {
        document.title = `${companyFetchRes.data.简称}`
      }
      break
    default:
      if (meta && meta.title) {
        document.title = meta.title
      } else if (document.title !== 'Alpha') {
        document.title = 'Alpha'
      }
      break
  }
}

export default router
